import api from '../axios.js'

/**
 * Gold Balance
 * @param {Object} params
 * @param {String} params.user_id - User ID
 * @returns {Promise} - Axios response Promise
 */
export const getGoldBalance = async (params) => {
	const paramSend = {
		user_id: params.user_id,
	}

	return await api.get('/v2/balances/' +  paramSend.user_id + '/gold')
}